"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _component = _interopRequireDefault(require("@loadable/component"));

var _clsx = _interopRequireDefault(require("clsx"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _useTheme = _interopRequireDefault(require("@material-ui/core/styles/useTheme"));

var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));

var _Container = _interopRequireDefault(require("@material-ui/core/Container"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _PageContext = _interopRequireDefault(require("@micado-digital/react-ui/context/PageContext"));

var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));

var _Local = _interopRequireDefault(require("@micado-digital/react-ui/components/Local"));

var _fireEvent = _interopRequireDefault(require("../../utils/fireEvent"));

var _de = _interopRequireDefault(require("../../locals/de.json"));

var _en = _interopRequireDefault(require("../../locals/en.json"));

var _it = _interopRequireDefault(require("../../locals/it.json"));

var _ShopContext = _interopRequireDefault(require("../../context/ShopContext"));

var _ProductDetailContext = _interopRequireDefault(require("../../ProductDetail/context/ProductDetailContext"));

var _Availability = _interopRequireDefault(require("./Availability"));

var _Bookmark = _interopRequireDefault(require("./Bookmark"));

var _CartButton = _interopRequireDefault(require("./CartButton"));

var _CombinationSelection = _interopRequireDefault(require("./CombinationSelection"));

var _Gallery = _interopRequireDefault(require("./Gallery"));

var _ItemNumber = _interopRequireDefault(require("./ItemNumber"));

var _Price = _interopRequireDefault(require("./Price"));

var _Quantity = _interopRequireDefault(require("./Quantity"));

var _Rating = _interopRequireDefault(require("./Rating"));

var _Tags = _interopRequireDefault(require("./Tags"));

var _Title = _interopRequireDefault(require("./Title"));

var _VoucherSelection = _interopRequireDefault(require("./VoucherSelection"));

var _getAvailability = _interopRequireDefault(require("../../utils/getAvailability"));

var _ProductDetail = _interopRequireDefault(require("./ProductDetail01.styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Accordion = (0, _component.default)(function () {
  return import("../../components/Accordion");
});
var Description = (0, _component.default)(function () {
  return import("./Description");
});
var Documents = (0, _component.default)(function () {
  return import("./Documents");
});
var Features = (0, _component.default)(function () {
  return import("./Features");
});
var ProductDetail = (0, _component.default)(function () {
  return import("../../ProductDetail");
});
var ProductSelection = (0, _component.default)(function () {
  return import("./ProductSelection");
});
var Ratings = (0, _component.default)(function () {
  return import("./Ratings");
});
var Recommendations = (0, _component.default)(function () {
  return import("./Recommendations");
});

var Content = function Content(_ref) {
  var displayedFeatures = _ref.displayedFeatures;

  var _useContext = (0, _react.useContext)(_PageContext.default),
      _useContext2 = _slicedToArray(_useContext, 1),
      pageData = _useContext2[0];

  var _ref2 = pageData || {},
      _ref2$lang = _ref2.lang,
      lang = _ref2$lang === void 0 ? "de" : _ref2$lang;

  var _useContext3 = (0, _react.useContext)(_ShopContext.default),
      shopData = _useContext3.shopData;

  var _useContext4 = (0, _react.useContext)(_ProductDetailContext.default),
      productDetailData = _useContext4.productDetailData;

  var _ref3 = productDetailData || {},
      available = _ref3.available,
      availableCount = _ref3.availableCount,
      descriptions = _ref3.descriptions,
      documents = _ref3.documents,
      features = _ref3.features,
      _ref3$ratingActive = _ref3.ratingActive,
      ratingActive = _ref3$ratingActive === void 0 ? false : _ref3$ratingActive,
      referenceIDs = _ref3.referenceIDs,
      type = _ref3.type,
      _ref3$_loading = _ref3._loading,
      _loading = _ref3$_loading === void 0 ? false : _ref3$_loading;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      fetchDate = _useState2[0],
      setFetchDate = _useState2[1];

  var theme = (0, _useTheme.default)();
  var isDesktop = (0, _useMediaQuery.default)(theme.breakpoints.up("md"));
  var css = (0, _ProductDetail.default)();
  var l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default,
      it: _it.default
    }
  });
  (0, _react.useEffect)(function () {
    if ((0, _isEmpty.default)(productDetailData) || (0, _isEmpty.default)(shopData) || _loading) return;
    (0, _fireEvent.default)("view-item", {
      product: productDetailData,
      shop: shopData
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_loading, JSON.stringify(shopData)]);
  var isAvailable = (0, _react.useMemo)(function () {
    return (0, _getAvailability.default)(available, availableCount);
  }, [available, availableCount]);
  return /*#__PURE__*/_react.default.createElement(_Container.default, {
    className: (0, _clsx.default)(css.productDetail, "mco-shop-product-detail"),
    maxWidth: "lg"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: css.wrapper
  }, !isDesktop && /*#__PURE__*/_react.default.createElement(_Gallery.default, {
    mediaFormats: {
      xs: "product-detail"
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.rightColumn, "mco-shop-product-detail__right-column")
  }, /*#__PURE__*/_react.default.createElement(_Tags.default, null), /*#__PURE__*/_react.default.createElement(_Title.default, null), /*#__PURE__*/_react.default.createElement(_ItemNumber.default, null), /*#__PURE__*/_react.default.createElement(_Price.default, {
    lang: lang
  }), /*#__PURE__*/_react.default.createElement(_Availability.default, {
    isAvailable: isAvailable,
    count: availableCount,
    lang: lang
  }), ratingActive && /*#__PURE__*/_react.default.createElement(_Rating.default, {
    key: fetchDate
  }), /*#__PURE__*/_react.default.createElement(ProductSelection, {
    lang: lang
  }, type === "voucher" ? /*#__PURE__*/_react.default.createElement(_VoucherSelection.default, {
    lang: lang
  }) : /*#__PURE__*/_react.default.createElement(_CombinationSelection.default, {
    fetch: available,
    lang: lang
  }), isAvailable && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "mco-shop-product-detail-buttons"
  }, type !== "voucher" && /*#__PURE__*/_react.default.createElement(_Quantity.default, {
    max: availableCount
  }), /*#__PURE__*/_react.default.createElement(_CartButton.default, {
    lang: lang
  }), /*#__PURE__*/_react.default.createElement(_Bookmark.default, null))))), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.content, "mco-shop-product-detail__content")
  }, isDesktop && /*#__PURE__*/_react.default.createElement(_Gallery.default, {
    mediaFormats: {
      xs: "product-detail"
    }
  }), !(0, _isEmpty.default)(descriptions) && /*#__PURE__*/_react.default.createElement(Accordion, {
    defaultExpanded: false,
    title: l("reactShop.productDetail.title.description")
  }, /*#__PURE__*/_react.default.createElement(Description, {
    defaultExpanded: true,
    lang: lang
  })), !(0, _isEmpty.default)(features) && /*#__PURE__*/_react.default.createElement(Accordion, {
    defaultExpanded: false,
    title: l("reactShop.productDetail.title.features")
  }, /*#__PURE__*/_react.default.createElement(Features, {
    lang: lang
  })), !(0, _isEmpty.default)(documents) && type !== "voucher" && /*#__PURE__*/_react.default.createElement(Accordion, {
    defaultExpanded: false,
    title: l("reactShop.productDetail.title.documents")
  }, /*#__PURE__*/_react.default.createElement(Documents, {
    lang: lang
  })), ratingActive && /*#__PURE__*/_react.default.createElement(Accordion, {
    defaultExpanded: true,
    title: l("reactShop.productDetail.title.ratings")
  }, /*#__PURE__*/_react.default.createElement(Ratings, {
    key: fetchDate,
    lang: lang,
    setFetchDate: setFetchDate
  })))), !(0, _isEmpty.default)(referenceIDs) && /*#__PURE__*/_react.default.createElement("div", {
    className: css.recommendations
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "h4"
  }, /*#__PURE__*/_react.default.createElement(_Local.default, {
    identifier: "reactShop.productDetail.headlines.recommendations",
    l: l
  })), /*#__PURE__*/_react.default.createElement(Recommendations, {
    displayedFeatures: displayedFeatures,
    lang: lang
  })));
};

var ProductDetail01 = function ProductDetail01(_ref4) {
  var _ref4$defaultLang = _ref4.defaultLang,
      defaultLang = _ref4$defaultLang === void 0 ? "de" : _ref4$defaultLang,
      _ref4$displayedFeatur = _ref4.displayedFeatures,
      displayedFeatures = _ref4$displayedFeatur === void 0 ? [] : _ref4$displayedFeatur;

  var _useContext5 = (0, _react.useContext)(_PageContext.default),
      _useContext6 = _slicedToArray(_useContext5, 1),
      pageData = _useContext6[0];

  var _ref5 = pageData || {},
      pageDataLang = _ref5.lang,
      data = _ref5.setupDetails;

  var _useState3 = (0, _react.useState)(defaultLang),
      _useState4 = _slicedToArray(_useState3, 2),
      lang = _useState4[0],
      setLang = _useState4[1];

  (0, _react.useEffect)(function () {
    if (!pageDataLang) return;
    setLang(pageDataLang);
  }, [pageDataLang]);
  return /*#__PURE__*/_react.default.createElement(ProductDetail, {
    data: data ? JSON.parse(data) : null,
    lang: lang,
    pagename: window.location.pathname
  }, /*#__PURE__*/_react.default.createElement(Content, {
    displayedFeatures: displayedFeatures
  }));
};

ProductDetail01.propTypes = {
  defaultLang: _propTypes.default.string,
  displayedFeatures: _propTypes.default.array
};
var _default = ProductDetail01;
exports.default = _default;